import React from "react";

import { AvatarGroup, Text } from "@performyard/py-components";

import { config } from "../config";

type PageHeaderProps = {
	workspaceName: string;
	participants: Array<{ _id: string; name: string }>;
};

const PageHeader = ({ workspaceName, participants }: PageHeaderProps): React.ReactElement => {
	return (
		<div className="flex flex-col py-6">
			<div className="flex w-full flex-row items-center space-x-2">
				<div className="py-line-clamp-1" style={{ maxWidth: config.layout.pageHeaderMaxWidth }}>
					<Text size="heading-5" weight="semi-bold">
						{workspaceName}
					</Text>
				</div>
				<AvatarGroup
					employees={participants}
					hasLinks={true}
					maxLength={6}
					size={20}
					employeeNameTooltip={true}
					modalTitle="Workspace Participants"
				/>
			</div>
			<Text size="caption" weight="regular" color="neutral-7">
				{participants.length} participants
			</Text>
		</div>
	);
};

export default PageHeader;
